<template>
  <div class="home-page">
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-overlay"></div>
      <div class="container hero-content">
        <div class="hero-text">
          <span class="hero-badge">Universitas Lampung</span>
          <h1>Tracer Study</h1>
          <p>Penelusuran alumni untuk mengetahui transisi dari dunia pendidikan tinggi ke dunia kerja, situasi kerja, dan pemanfaatan kompetensi selama kuliah.</p>
          <div class="hero-actions">
            <router-link to="/kuesioner" class="btn-hero-primary">
              <i class="bx bx-edit-alt"></i> Isi Kuesioner
            </router-link>
            <router-link to="/statistik" class="btn-hero-secondary">
              <i class="bx bx-bar-chart-alt-2"></i> Lihat Statistik
            </router-link>
          </div>
        </div>
        <div class="hero-visual">
          <div class="hero-stats-card">
            <div class="stats-period" v-if="heroStats.periode">{{ heroStats.periode }}</div>
            <div class="stat-item">
              <span class="stat-number">{{ formatNumber(heroStats.total_alumni) }}</span>
              <span class="stat-label">Total Alumni</span>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <span class="stat-number">{{ formatNumber(heroStats.total_responden) }}</span>
              <span class="stat-label">Responden</span>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <span class="stat-number">{{ heroStats.response_rate }}%</span>
              <span class="stat-label">Response Rate</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- About Section -->
    <section class="about-section">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">Tentang</span>
          <h2>Apa itu Tracer Study?</h2>
        </div>
        <div class="about-grid">
          <div class="about-card">
            <div class="about-icon"><i class="bx bxs-user-detail"></i></div>
            <h3>Penelusuran Alumni</h3>
            <p>Kegiatan penelusuran alumni dalam hal pencarian kerja, situasi kerja, dan pemanfaatan kompetensi selama kuliah di universitas.</p>
          </div>
          <div class="about-card">
            <div class="about-icon"><i class="bx bxs-bar-chart-alt-2"></i></div>
            <h3>IKU & Pelaporan</h3>
            <p>Data tracer study digunakan untuk menghitung Indikator Kinerja Utama (IKU) perguruan tinggi, khususnya IKU 2 (lulusan produktif) yang dilaporkan ke PDDIKTI setiap tahun.</p>
          </div>
          <div class="about-card">
            <div class="about-icon"><i class="bx bxs-analyse"></i></div>
            <h3>Pengembangan Kurikulum</h3>
            <p>Menyajikan data relevansi antara kompetensi lulusan dan kebutuhan dunia kerja sebagai dasar perbaikan kurikulum dan proses pembelajaran.</p>
          </div>
          <div class="about-card">
            <div class="about-icon"><i class="bx bxs-check-shield"></i></div>
            <h3>Akreditasi & Mutu</h3>
            <p>Menjadi komponen penting dalam asesmen akreditasi BAN-PT, evaluasi mutu internal, serta pemenuhan standar nasional pendidikan tinggi.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- How It Works -->
    <section class="steps-section">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">Cara Mengisi</span>
          <h2>Langkah Pengisian</h2>
        </div>
        <div class="steps-grid">
          <div class="step-card">
            <div class="step-number">1</div>
            <h3>Pilih Kuesioner</h3>
            <p>Pilih jenis kuesioner yang sesuai dengan jenjang pendidikan Anda.</p>
          </div>
          <div class="step-arrow"><i class="bx bx-right-arrow-alt"></i></div>
          <div class="step-card">
            <div class="step-number">2</div>
            <h3>Verifikasi Identitas</h3>
            <p>Masukkan NPM dan tanggal lahir untuk memverifikasi data alumni Anda.</p>
          </div>
          <div class="step-arrow"><i class="bx bx-right-arrow-alt"></i></div>
          <div class="step-card">
            <div class="step-number">3</div>
            <h3>Isi Kuesioner</h3>
            <p>Jawab pertanyaan tentang status pekerjaan, penghasilan, dan kompetensi.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="cta-section">
      <div class="container">
        <div class="cta-card">
          <h2>Sudah Siap Mengisi?</h2>
          <p>Partisipasi Anda sangat berarti untuk pengembangan Universitas Lampung.</p>
          <router-link to="/kuesioner" class="btn-cta">
            Mulai Isi Kuesioner <i class="bx bx-right-arrow-alt"></i>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SurveyService from "@/services/survey.service";

export default {
  name: "Home",
  data: function () {
    return {
      heroStats: {
        total_alumni: 0,
        total_responden: 0,
        response_rate: 0,
        periode: '',
      },
    };
  },
  mounted: function () {
    SurveyService.getPublicStats('')
      .then(function (res) {
        this.heroStats = {
          total_alumni: res.data.total_alumni || 0,
          total_responden: res.data.total_responden || 0,
          response_rate: res.data.response_rate || 0,
          periode: res.data.periode || '',
        };
      }.bind(this))
      .catch(function () {});
  },
  methods: {
    formatNumber: function (num) {
      return Number(num || 0).toLocaleString('id-ID');
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap');

.home-page {
  font-family: 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #1a1a1a;
}

/* Hero */
.hero-section {
  position: relative;
  background: linear-gradient(135deg, #002a1c 0%, #003E29 40%, #00553a 100%);
  padding: 140px 0 80px;
  overflow: hidden;
}

.hero-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: radial-gradient(circle at 70% 30%, rgba(255,255,255,0.05) 0%, transparent 60%);
}

.hero-content {
  position: relative;
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 48px;
  align-items: center;
}

.hero-badge {
  display: inline-block;
  padding: 6px 16px;
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 20px;
  color: rgba(255,255,255,0.9);
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  margin-bottom: 20px;
}

.hero-text h1 {
  color: #fff;
  font-size: 3rem;
  font-weight: 700;
  margin: 0 0 16px;
  line-height: 1.15;
}

.hero-text p {
  color: rgba(255,255,255,0.75);
  font-size: 1.05rem;
  line-height: 1.7;
  margin: 0 0 32px;
  max-width: 500px;
}

.hero-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-hero-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 28px;
  background: #fff;
  color: #003E29;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.btn-hero-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.2);
  text-decoration: none;
  color: #003E29;
}

.btn-hero-secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 28px;
  background: transparent;
  color: #fff;
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  transition: all 0.2s;
}

.btn-hero-secondary:hover {
  border-color: rgba(255,255,255,0.6);
  background: rgba(255,255,255,0.08);
  text-decoration: none;
  color: #fff;
}

.hero-stats-card {
  background: rgba(255,255,255,0.08);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 20px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.stats-period {
  text-align: center;
  font-size: 0.8rem;
  font-weight: 600;
  color: rgba(255,255,255,0.7);
  letter-spacing: 0.5px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.stat-item {
  text-align: center;
}

.stat-number {
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: #fff;
}

.stat-label {
  font-size: 0.85rem;
  color: rgba(255,255,255,0.6);
  margin-top: 4px;
}

.stat-divider {
  height: 1px;
  background: rgba(255,255,255,0.1);
}

/* About Section */
.about-section {
  padding: 80px 0;
  background: #f8faf9;
}

.section-header {
  text-align: center;
  margin-bottom: 48px;
}

.section-tag {
  display: inline-block;
  padding: 4px 14px;
  background: #e8f5e9;
  color: #2e7d32;
  border-radius: 16px;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 12px;
}

.section-header h2 {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}

.about-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.about-card {
  background: #fff;
  padding: 32px 28px;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
  transition: all 0.2s;
  text-align: center;
}

.about-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);
}

.about-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: linear-gradient(135deg, #003E29, #00664a);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  margin: 0 auto 16px;
}

.about-card h3 {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 10px;
  color: #1a1a1a;
}

.about-card p {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

/* Steps Section */
.steps-section {
  padding: 80px 0;
  background: #fff;
}

.steps-grid {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.step-card {
  background: #f8faf9;
  border-radius: 16px;
  padding: 32px 28px;
  text-align: center;
  flex: 1;
  max-width: 280px;
  transition: all 0.2s;
}

.step-card:hover {
  background: #f0f7f4;
}

.step-number {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #003E29;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0 auto 16px;
}

.step-card h3 {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 8px;
  color: #1a1a1a;
}

.step-card p {
  font-size: 0.85rem;
  color: #666;
  line-height: 1.5;
  margin: 0;
}

.step-arrow {
  font-size: 28px;
  color: #ccc;
}

/* CTA Section */
.cta-section {
  padding: 0 0 80px;
  background: #fff;
}

.cta-card {
  background: linear-gradient(135deg, #003E29, #00553a);
  border-radius: 20px;
  padding: 48px;
  text-align: center;
}

.cta-card h2 {
  color: #fff;
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0 0 12px;
}

.cta-card p {
  color: rgba(255,255,255,0.7);
  font-size: 1rem;
  margin: 0 0 28px;
}

.btn-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 32px;
  background: #fff;
  color: #003E29;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  transition: all 0.2s;
}

.btn-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.2);
  text-decoration: none;
  color: #003E29;
}

/* Responsive */
@media (max-width: 991px) {
  .hero-content {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .hero-text p {
    max-width: 100%;
  }

  .hero-actions {
    justify-content: center;
  }

  .hero-stats-card {
    flex-direction: row;
    justify-content: center;
  }

  .stat-divider {
    width: 1px;
    height: auto;
  }

  .about-grid {
    grid-template-columns: repeat(2, 1fr);
    max-width: 600px;
    margin: 0 auto;
  }

  .steps-grid {
    flex-direction: column;
  }

  .step-arrow {
    transform: rotate(90deg);
  }

  .step-card {
    max-width: 100%;
    width: 100%;
  }
}

@media (max-width: 576px) {
  .about-grid {
    grid-template-columns: 1fr;
    max-width: 400px;
  }

  .hero-section {
    padding: 120px 0 60px;
  }

  .hero-text h1 {
    font-size: 2rem;
  }

  .hero-stats-card {
    flex-direction: column;
  }

  .stat-divider {
    width: auto;
    height: 1px;
  }

  .hero-actions {
    flex-direction: column;
  }

  .btn-hero-primary, .btn-hero-secondary {
    justify-content: center;
  }

  .cta-card {
    padding: 32px 20px;
  }
}
</style>
